function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { T, useTranslate } from 'shared/helper/translate';
import ModalConfirm from 'shared/components/ModalConfirm';
import trackRubriqEvent from 'rubriq/helpers/trackRubriqEvent';
import { removePreferredGroup } from '../actions';
import { getPaddlePlanIdForCurrentPlan } from '../reducer';
import DropdownButton from '../components/DropdownButton';
import DropdownHelpCenterLink from '../components/DropdownHelpCenterLink';
import PlanManagementButton from './PlanManagementButton';
var RubriqPlanDropdown = function RubriqPlanDropdown(_ref) {
  var _curiePlan$planName;
  var curiePlan = _ref.plan,
    onPaddleCheckoutClose = _ref.onPaddleCheckoutClose;
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showConfirm = _useState2[0],
    setShowConfirm = _useState2[1];
  var dispatch = useDispatch();
  var paddlePlanId = useSelector(getPaddlePlanIdForCurrentPlan);
  var planNameMap = {
    premium_including_translation: 'Rubriq Premium with Translation',
    premium_editing_only: 'Rubriq Premium'
  };
  var rawPlanName = (_curiePlan$planName = curiePlan.planName) !== null && _curiePlan$planName !== void 0 ? _curiePlan$planName : null;
  var formattedPlanName = planNameMap[rawPlanName] || rawPlanName;
  var handleGetHelpClick = function handleGetHelpClick() {
    trackRubriqEvent('Clicked on the Get Help', {
      action: 'Get help',
      source: 'plan_dropdown'
    });
  };
  var getDropdownItems = function getDropdownItems() {
    var premiumItems = function premiumItems() {
      var items = [];
      if (curiePlan.status === 'active' || curiePlan.status === 'error') {
        var _curiePlan$grantedFro, _curiePlan$grantedFro2;
        items.push({
          label: 'Change billing information',
          element: /*#__PURE__*/React.createElement(PlanManagementButton, {
            classicUrl: (_curiePlan$grantedFro = curiePlan.grantedFrom.paddleSubscription) === null || _curiePlan$grantedFro === void 0 ? void 0 : _curiePlan$grantedFro.updateUrl,
            targetAction: "update",
            onClose: onPaddleCheckoutClose,
            paddlePlanId: paddlePlanId,
            onClick: function onClick() {
              return trackRubriqEvent('Change billing information Clicked', {
                action: 'Change billing information',
                planType: curiePlan.type,
                planName: formattedPlanName,
                planStatus: curiePlan.status,
                endsAt: curiePlan.endsAt,
                billingCycle: curiePlan.subscriptionInterval
              });
            }
          }, /*#__PURE__*/React.createElement("span", {
            className: "dropdown-item fw-normal"
          }, /*#__PURE__*/React.createElement(T, {
            source: "Change billing information"
          })))
        }, {
          label: 'Cancel',
          element: /*#__PURE__*/React.createElement(PlanManagementButton, {
            classicUrl: (_curiePlan$grantedFro2 = curiePlan.grantedFrom.paddleSubscription) === null || _curiePlan$grantedFro2 === void 0 ? void 0 : _curiePlan$grantedFro2.cancelUrl,
            targetAction: "cancel",
            onClose: onPaddleCheckoutClose,
            paddlePlanId: paddlePlanId,
            onClick: function onClick() {
              return trackRubriqEvent('DropDown Cancel Clicked', {
                action: 'Cancel',
                planName: formattedPlanName,
                planStatus: curiePlan.status,
                endsAt: curiePlan.endsAt,
                billingCycle: curiePlan.subscriptionInterval
              });
            }
          }, /*#__PURE__*/React.createElement("span", {
            className: "dropdown-item fw-normal"
          }, /*#__PURE__*/React.createElement(T, {
            source: "Cancel"
          })))
        });
      }
      items.push({
        label: 'Get help',
        element: /*#__PURE__*/React.createElement(DropdownHelpCenterLink, {
          onClick: handleGetHelpClick
        })
      });
      return items;
    };
    var starterItems = function starterItems() {
      return [{
        label: 'Get help',
        element: /*#__PURE__*/React.createElement(DropdownHelpCenterLink, {
          onClick: handleGetHelpClick
        })
      }];
    };
    var preferredGroupItems = function preferredGroupItems() {
      return [{
        label: 'Leave Preferred Group',
        element: /*#__PURE__*/React.createElement("button", {
          type: "button",
          className: "dropdown-item btn btn-link fw-normal",
          onClick: function onClick() {
            return setShowConfirm(true);
          }
        }, t('Leave Preferred Group'))
      }, {
        label: 'View all plans',
        action: '/rubriq/plan/subscribe'
      }, {
        label: 'Get help',
        element: /*#__PURE__*/React.createElement(DropdownHelpCenterLink, {
          onClick: handleGetHelpClick
        })
      }];
    };
    var chinaItems = function chinaItems() {
      return [{
        label: 'View Invoice',
        action: '/researcher/invoices'
      }, {
        label: 'Get help',
        element: /*#__PURE__*/React.createElement(DropdownHelpCenterLink, {
          onClick: handleGetHelpClick
        })
      }];
    };
    switch (curiePlan.type) {
      case 'premium':
        return curiePlan.grantedFrom.paddleSubscription ? premiumItems() : chinaItems();
      case 'free_trial':
        return starterItems();
      case 'preferred_group':
        return preferredGroupItems();
      default:
        return [];
    }
  };
  var items = getDropdownItems();
  return items.length ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DropdownButton, {
    text: t('curie.more'),
    items: items
  }), ' ', /*#__PURE__*/React.createElement(ModalConfirm, {
    appElement: "#researcher-app",
    close: function close() {
      return setShowConfirm(false);
    },
    show: showConfirm,
    yesAction: function yesAction() {
      return dispatch(removePreferredGroup());
    },
    yesText: "continue",
    noText: "cancel",
    title: "Leave Preferred Group"
  }, /*#__PURE__*/React.createElement("p", null, t('curie.leave-preferred-group-confirmation-message')))) : null;
};
export default RubriqPlanDropdown;